import Konva from "konva";

export function createBorder(layer, crop, width, height) {

  const canvas = createCavnas(width, height, crop);
  const img = new Konva.Image({
    image: canvas,
    width: canvas.width,
    height: canvas.height,
    x: -width * 0.5 + crop.width * 0.5,
    y: -height * 0.5 + crop.height * 0.5
  });
  layer.add(img);


  const borderWidth = 4;
  const border = new Konva.Rect({
    x:  - borderWidth * 0.5,
    y:  - borderWidth * 0.5,
    width: crop.width + borderWidth,
    height: crop.height + borderWidth,
    stroke: "rgba(0, 0, 0, 0.6)",
    strokeWidth: borderWidth
  });
  layer.add(border);

  createLine(layer, crop, borderWidth);


}

function createLine(layer, crop, borderWidth) {
  const lineSize = 15;
  const topL = - borderWidth * 0.5;
  const topR = crop.width + borderWidth * 0.5;
  const btmR = crop.height + borderWidth * 0.5;
  const props = {
    points: [topL + lineSize, 0, topL, 0, topL, lineSize],
    stroke: 'white',
    strokeWidth: borderWidth
  };
  const line = new Konva.Line(props);
  layer.add(line);

  props.points = [topR - lineSize, 0, topR, 0, topR, lineSize];
  const line2 = new Konva.Line(props);
  layer.add(line2);
  props.points = [topR - lineSize, btmR, topR, btmR, topR, btmR - lineSize];

  const line3 = new Konva.Line(props);
  layer.add(line3);

  props.points = [topL + lineSize, btmR, topL, btmR, topL, btmR - lineSize];
  const line4 = new Konva.Line(props);
  layer.add(line4);
}

function createCavnas(w, h, crop) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  console.log("[border] w", w, h, crop);
  canvas.width = w;
  canvas.height = h;

  context.fillStyle = "rgba(0, 0, 0, 0.6)";
  context.fillRect(0, 0, w * 2, h * 2);
  context.globalCompositeOperation = "destination-out";

  context.fillStyle = "rgba(255, 255,255, 1)";
  context.fillRect(
    (w - crop.width) * 0.5,
    (h - crop.height) * 0.5,
    crop.width,
    crop.height
  );

  return canvas;
}
